/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { FadeInOutView, Text, styles } from "UpduoLibrary";
import { skaleBlack, colorWithOpacity } from "config/UpduoColors";

interface MainOverlayProps {
  showRecordingDot: boolean;
  showButtons: boolean;
}

export default function MainOverlay({
  showRecordingDot,
  showButtons,
}: MainOverlayProps) {
  return (
    <View style={styles.mainOverlay}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <FadeInOutView
          duration={500}
          visible={showRecordingDot && showButtons}
          style={[styles.recordDetailBar, { marginTop: 10 }]}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <View style={styles.recordDot} />
            <Text
              style={{ color: colorWithOpacity(skaleBlack, 0.6), fontSize: 12 }}
            >
              {"REC"}
            </Text>
          </View>
        </FadeInOutView>
      </View>
    </View>
  );
}
